import { SVGProps } from "react";

const WhatsAppIcon = ({ fill, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_757_3576)">
        <path
          d="M6.5015 0.460632H6.4985C3.19025 0.460632 0.5 3.15163 0.5 6.46063C0.5 7.77313 0.923 8.98963 1.64225 9.97738L0.8945 12.2064L3.20075 11.4691C4.1495 12.0976 5.28125 12.4606 6.5015 12.4606C9.80975 12.4606 12.5 9.76888 12.5 6.46063C12.5 3.15238 9.80975 0.460632 6.5015 0.460632Z"
          fill={fill ?? "#4CAF50"}
        />
        <path
          d="M9.99437 8.93339C9.84962 9.34214 9.27512 9.68115 8.81687 9.78015C8.50337 9.8469 8.09387 9.90015 6.71537 9.32865C4.95212 8.59815 3.81663 6.80639 3.72813 6.69015C3.64338 6.57389 3.01562 5.7414 3.01562 4.8804C3.01562 4.0194 3.45288 3.60015 3.62913 3.42015C3.77388 3.2724 4.01312 3.2049 4.24262 3.2049C4.31687 3.2049 4.38363 3.20865 4.44362 3.21165C4.61988 3.21915 4.70837 3.22965 4.82463 3.5079C4.96938 3.85665 5.32187 4.71765 5.36387 4.80615C5.40662 4.89465 5.44938 5.01465 5.38938 5.1309C5.33313 5.2509 5.28362 5.30414 5.19512 5.40615C5.10662 5.50815 5.02262 5.58615 4.93412 5.69565C4.85312 5.79089 4.76162 5.8929 4.86363 6.06915C4.96563 6.24165 5.31813 6.81689 5.83712 7.27889C6.50687 7.87514 7.04987 8.06565 7.24412 8.14665C7.38887 8.20665 7.56137 8.1924 7.66712 8.0799C7.80137 7.93515 7.96712 7.69515 8.13587 7.4589C8.25587 7.2894 8.40737 7.26839 8.56637 7.32839C8.72837 7.38464 9.58562 7.80839 9.76188 7.89614C9.93813 7.98464 10.0544 8.02665 10.0971 8.1009C10.1391 8.17515 10.1391 8.5239 9.99437 8.93339Z"
          fill={"#FAFAFA"}
        />
      </g>
      <defs>
        <clipPath id="clip0_757_3576">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.5 0.460632)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WhatsAppIcon;
